<template>
    <HFOLO001FOODCON v-if="useFoodconView" />
    <div v-else
        :class="['sub_contents login', { 'popup-window-mode': isPopupWindowMode, 'popup-standalone-desktop': isStandaloneDesktop }]">
        <div class="cont_center">
            <div class="login_box_area login_box_area2">
                <div class="brand_title_row" aria-hidden="true">
                    <img src="@/assets/images/header/logo.png" alt="하이비타민" class="brand_logo_img" />
                    <h3 class="title_login title_inline">{{ popupMode === 'signup' ? '회원가입' : '로그인' }}</h3>
                </div>
                <p class="benefit_copy">
                    <span class="benefit_orange">하이비타민, 복지카드로 상시 청구할인</span>
                    <span class="benefit_default"> 받고 매달</span>
                    <br class="benefit_break_mobile" />
                    <span class="benefit_default"> 달라지는</span>
                    <span class="benefit_green"> 브랜드 혜택을 즐기세요.</span>
                </p>
                <p class="welcome_copy">카카오 계정으로 1초 로그인</p>

                <div class="login_input_area">
                    <div class="login_form_area" v-if="showLegacyIdPwLogin && popupMode === 'login'">
                        <ul class="login_input_list">
                            <li>
                                <InputText v-model="loginData.id" :placeholder="placeholderID"
                                    @input="hideErrorMessages" />
                            </li>
                            <li>
                                <InputText v-model="loginData.password" :placeholder="placeholderPW" type="password"
                                    @input="hideErrorMessages" />
                                <p v-if="invalidPassword" class="required login-error-message">
                                    로그인 정보가 올바르지 않습니다.
                                </p>
                            </li>
                        </ul>

                        <div class="login_check_area">
                            <CheckBox v-for="option in checkOptions" :key="option.value" :id="option.value"
                                :value="option.value" :label="option.label" v-model="selectedOptions"
                                @change="onCheckboxChange" />
                        </div>

                        <div class="btn_login_area">
                            <button @click="handleLogin" class="btn_type2">로그인</button>
                        </div>

                        <ul class="login_user_link">
                            <li>
                                <RouterLink to="/HFO_LO_002">아이디 찾기</RouterLink>
                            </li>
                            <li>
                                <RouterLink to="/HFO_LO_005">비밀번호 찾기</RouterLink>
                            </li>
                        </ul>
                    </div>

                    <div class="sns_login_wrapper">
                        <h4 class="sns_login_title">{{ popupMode === 'login' ? '로그인' : '회원가입' }}</h4>
                        <ul class="sns_login">
                            <li class="kakao_priority_item">
                                <a href="#" @click="kakaoLoginBtn" id="kakaoLogin" class="kakao_priority_link">
                                    <img src="@/assets/images/icon/join_kakao.png" alt="카카오로 시작하기" />
                                </a>
                            </li>
                            <li class="sns_divider" aria-hidden="true"><span>또는</span></li>
                            <li class="naver_secondary_item">
                                <div id="naver_id_login" style="display:none"></div>
                                <a href="#" @click="redirectToNaverLogin" class="naver_secondary_link">
                                    <img src="@/assets/images/icon/join_naver.png" alt="네이버로 시작하기" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <AlertPopup v-if="showAlert" :title="alertTitle" :message="alertMessage" :showClose="true"
            @close="closeAlert" />

        <LayerPopup v-model="showMarketingConsentPopup" title="마케팅 정보 수신 동의">
            <template #layer_content>
                <div class="term_check_area">
                    <div class="d_check">
                        <input type="checkbox" v-model="marketingConsent.checked" @change="updateMarketingSubOptions"
                            id="popup-marketing-all" />
                        <label for="popup-marketing-all">[선택] 통합 마케팅 정보 수신 동의</label>
                    </div>

                    <div class="marketing_check_area">
                        <div class="d_check">
                            <input type="checkbox" v-model="marketingConsent.emailChecked" id="popup-marketing-email"
                                @change="updateMarketingChecked" />
                            <label for="popup-marketing-email">카카오톡</label>
                        </div>

                        <div class="d_check">
                            <input type="checkbox" v-model="marketingConsent.smsChecked" id="popup-marketing-sms"
                                @change="updateMarketingChecked" />
                            <label for="popup-marketing-sms">문자</label>
                        </div>

                        <p class="marketing_noti">하이비타민의 통합 혜택 및 이벤트 안내를 카카오톡/문자로 받아보실 수 있습니다.</p>
                    </div>

                    <div class="layer_term_area" v-html="marketingTermsContent"></div>

                    <div class="btn_login_area popup_actions">
                        <button type="button" class="btn_type2" @click="confirmMarketingConsent">동의하고 계속</button>
                    </div>
                </div>
            </template>
        </LayerPopup>
    </div>
</template>

<script>
import { onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router";   // ← 이 줄 추가
import InputText from "@/components/InputText";
import CheckBox from "@/components/CheckBox";
import AlertPopup from "@/components/AlertPopup.vue";
import LayerPopup from "@/components/LayerPopup.vue";
import HFOLO001FOODCON from "@/pages/HFO_LO_001_FOODCON.vue";
import { postAxios, getAxios, putAxios } from "@/lib/AxiosCall";
import {
    LOCAL_STORAGE_HVM_SAVED_ID,
    LOCAL_STORAGE_HVM_USERINFO,
} from "@/lib/Constant";
import axios from "axios";
import { getKakaoAppKey, ensureKakaoInitialized } from "@/lib/SocialAuth";
import { encryptAES256 } from "@/lib/crypto";
import { SessionManager } from "@/lib/SessionManager";

export default {
    components: {
        InputText,
        CheckBox,
        AlertPopup,
        LayerPopup,
        HFOLO001FOODCON,
    },
    data() {
        return {
            loginData: { id: "", password: "" },
            placeholderID: "아이디(E-mail)를 입력해주세요.",
            placeholderPW: "비밀번호를 입력해 주세요.",
            selectedOptions: [],
            invalidPassword: false,
            checkOptions: [{ label: "아이디 저장", value: "2" }],
            showAlert: false,
            alertTitle: "알림",
            alertMessage: "",
            popupMode: "login",
            showLegacyIdPwLogin: false,
            kakaoHandled: false,
            ackReceived: false,
            ackTimeoutId: null,
            useFoodconView: false,
            isPopupWindowMode: true,
            isStandaloneDesktop: false,
            showMarketingConsentPopup: false,
            marketingTermsContent: "",
            marketingConsent: {
                checked: true,
                emailChecked: true,
                smsChecked: true,
            },
            pendingMemberCheckAction: "",
            pendingMarketingUpdate: false,
            // popup content size watcher (removed - opener handles sizing)
        };
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const userData = ref({
            USER_ID: "",
            USER_NAME: "",
            USER_EMAIL: "",
            USER_BIRTH: "",
            USER_GENDER: "",
            USER_IN_TYPE: "USER_IN_NORMAL",
        });
        return { route, router, userData };
    },
    mounted() {
        const { code, state, reason, mode } = this.$route.query;

        ensureKakaoInitialized();

        this.updateDisplayMode();
        window.addEventListener('resize', this.updateDisplayMode, false);

        this.resumeMarketingFlowIfNeeded();

        const initialFrc = typeof this.$route.query.frcUuid === "string"
            ? this.$route.query.frcUuid
            : "";
        if (initialFrc) {
            sessionStorage.setItem("foodcon_frc_uuid", initialFrc);
            sessionStorage.setItem("frcUuid", initialFrc);
        }

        const entryType = typeof this.$route.query.entryType === "string"
            ? this.$route.query.entryType.toLowerCase()
            : "";
        const rawUserId = typeof this.$route.query.userId === "string"
            ? this.$route.query.userId.trim()
            : "";
        const hasIncomingUserId = !!rawUserId;
        const isCpsEntry = entryType === "cps" && hasIncomingUserId;

        const entUuid = typeof this.$route.query.entUuid === "string"
            ? this.$route.query.entUuid
            : "";
        const frcUuid = typeof this.$route.query.frcUuid === "string"
            ? this.$route.query.frcUuid
            : "";
        const isTenantMemberEntry = !!(entUuid || frcUuid) && !isCpsEntry;

        if (!entUuid && !frcUuid) {
            this.clearStaleTenantContext();
        }

        if (entUuid) {
            sessionStorage.setItem("foodcon_ent_uuid", entUuid);
            sessionStorage.setItem("entUuid", entUuid);
        }
        if (frcUuid) {
            sessionStorage.setItem("foodcon_frc_uuid", frcUuid);
            sessionStorage.setItem("frcUuid", frcUuid);
        }

        if (isCpsEntry || isTenantMemberEntry) {
            this.saveCpsEntryContext();
        }

        // 핵심 정책: userId가 없으면 CPS로 보지 않는다.
        // entryType=cps로 들어와도 ent/frc가 있으면 기업/프랜차이즈(qr)로 정규화한다.
        if (!hasIncomingUserId && entryType === "cps" && (entUuid || frcUuid)) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    entryType: "qr",
                },
            });
        }

        // 로그인 분기
        // 1) 기본 하이비타민 로그인: 일반 화면 유지
        // 2) CPS 광고/혜택존 로그인(entryType=cps): FOODCON 전용 화면 사용
        // 3) 기업/프랜차이즈 회원 로그인(entUuid/frcUuid): FOODCON 화면에서 처리
        if (isCpsEntry || isTenantMemberEntry) {
            this.useFoodconView = true;
            return;
        }

        const storedMode = sessionStorage.getItem("hvm_popup_mode");
        this.popupMode = mode === "signup"
            ? "signup"
            : (storedMode === "signup" ? "signup" : "login");

        // 네이버 콜백
        if (code && state) {
            this.handleNaverCallback();
        }
        // 카카오 콜백
        else if (code && !state && !this.kakaoHandled) {
            this.handleKakaoCallback();
        }

        if (reason === "session-expired") {
            this.alertMessage =
                "세션이 만료되어 자동 로그아웃되었습니다. 다시 로그인해주세요.";
            this.showAlert = true;
        }

        this.initSavedId();

        // 네이버 SDK init (안전하게)
        try {
            const clientId = "8OoTuF36z_kbHk8X6i4F";
            if (window.naver_id_login) {
                const mode = this.popupMode === "signup" ? "signup" : "login";
                const currentOrigin = window.location.origin;
                this.naverLogin = new window.naver_id_login(
                    clientId,
                    `${currentOrigin}/HFO_LO_001_POP?mode=${mode}`
                );
                const naverState = this.naverLogin.getUniqState();
                this.naverLogin.setButton("green", 3, 100);
                this.naverLogin.setDomain(currentOrigin);
                this.naverLogin.setState(naverState);
                this.naverLogin.setPopup();
                this.naverLogin.init_naver_id_login();
            }
        } catch (e) { console.warn('naver init failed', e); }

        // ACK 수신 대기: 부모가 HVM_LOGIN_ACK를 보내면 팝업을 닫음
        window.addEventListener('message', this.handleAckMessage, false);
    },
    beforeUnmount() {
        window.removeEventListener('message', this.handleAckMessage, false);
        window.removeEventListener('resize', this.updateDisplayMode, false);
        if (this.ackTimeoutId) {
            clearTimeout(this.ackTimeoutId);
            this.ackTimeoutId = null;
        }
        this.stopContentSizeWatcher();
    },
    methods: {
        clearStaleTenantContext() {
            const tenantKeys = [
                "foodcon_ent_uuid",
                "foodcon_frc_uuid",
                "foodcon_ent_seq",
                "entUuid",
                "frcUuid",
                "entSeq",
            ];

            tenantKeys.forEach((key) => {
                sessionStorage.removeItem(key);
                localStorage.removeItem(key);
            });

            try {
                const raw = sessionStorage.getItem("cps_entry_context") || localStorage.getItem("cps_entry_context");
                if (!raw) return;

                const context = JSON.parse(raw);
                delete context.entUuid;
                delete context.frcUuid;
                const serialized = JSON.stringify(context);
                sessionStorage.setItem("cps_entry_context", serialized);
                localStorage.setItem("cps_entry_context", serialized);
            } catch (_e) {
                sessionStorage.removeItem("cps_entry_context");
                localStorage.removeItem("cps_entry_context");
            }
        },
        updateDisplayMode() {
            try {
                const hasOpener = !!(window.opener && !window.opener.closed);
                const isDesktop = window.innerWidth >= 1024;
                this.isPopupWindowMode = hasOpener;
                this.isStandaloneDesktop = !hasOpener && isDesktop;
            } catch (_e) {
                this.isPopupWindowMode = true;
                this.isStandaloneDesktop = false;
            }
        },
        getKakaoRedirectUri() {
            return `${window.location.origin}/HFO_LO_001_POP`;
        },
        getPopupModeParam() {
            return this.popupMode === "signup" ? "signup" : "login";
        },
        resizeForKakaoAuthorization() {
            try {
                if (!(window.opener && !window.opener.closed)) return;

                const screenWidth = window.screen?.availWidth || 1024;
                const screenHeight = window.screen?.availHeight || 900;
                const popupWidth = Math.min(1024, Math.max(320, screenWidth - 24));
                const popupHeight = Math.min(900, Math.max(480, screenHeight - 24));
                const left = Math.max(0, Math.floor((screenWidth - popupWidth) / 2));
                const top = Math.max(0, Math.floor((screenHeight - popupHeight) / 2));

                window.resizeTo(popupWidth, popupHeight);
                window.moveTo(left, top);
            } catch (_e) {
                // 브라우저가 팝업 크기 조정을 제한해도 카카오 인가 흐름은 계속한다.
            }
        },
        kakaoLoginBtn() {
            ensureKakaoInitialized();
            // 카카오 Redirect URI는 콘솔 등록값과 정확히 일치해야 하므로 query를 붙이지 않음
            // mode는 세션에 저장해 콜백 후 복원
            sessionStorage.setItem("hvm_popup_mode", this.getPopupModeParam());
            this.resizeForKakaoAuthorization();
            window.Kakao.Auth.authorize({
                redirectUri: this.getKakaoRedirectUri(),
                scope: "plusfriends",
            });
        },
        async handleKakaoCallback() {
            this.kakaoHandled = true;
            const code = this.$route.query.code;
            try {
                const tokenRes = await axios.post(
                    "https://kauth.kakao.com/oauth/token",
                    null,
                    {
                        params: {
                            grant_type: "authorization_code",
                            client_id: getKakaoAppKey(),
                            redirect_uri: this.getKakaoRedirectUri(),
                            code,
                        },
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
                        },
                    }
                );
                console.log("카카오 access_token:", tokenRes.data.access_token);
                window.Kakao.Auth.setAccessToken(tokenRes.data.access_token);
                sessionStorage.setItem('kakao_access_token', tokenRes.data.access_token || '');

                const profile = await window.Kakao.API.request({
                    url: "/v2/user/me",
                });
                console.log("카카오 profile 전체:", profile);

                if (!profile || !profile.id) {
                    alert("카카오 profile 정보가 올바르지 않습니다.");
                    return;
                }

                const acct = profile.kakao_account || {};
                this.userData.USER_ID = profile.id;
                this.userData.USER_MOBILE = acct.phone_number;
                this.userData.USER_NAME = acct.name || "";
                this.userData.USER_EMAIL = acct.email || "";
                this.userData.USER_BIRTH = acct.birthday || (acct.birthyear ? acct.birthyear + "-" + acct.birthday : "");
                this.userData.USER_GENDER = acct.gender || "";
                this.userData.USER_IN_TYPE = "USER_IN_KAKAO";
                sessionStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(this.userData));
                sessionStorage.setItem("userData", JSON.stringify(this.userData));
                await this.getMemberCheck(String(profile.id));
            } catch (err) {
                console.error("Kakao login error:", err);
                if (window.Kakao.Auth.getAccessToken()) {
                    await window.Kakao.API.request({ url: "/v1/user/unlink" });
                    window.Kakao.Auth.setAccessToken(undefined);
                }
                sessionStorage.removeItem('kakao_access_token');
                alert("카카오 로그인에 실패했습니다. 다시 시도해주세요.");
            } finally {
                // 카카오 콜백 처리 후 임시 mode 정리
                sessionStorage.removeItem("hvm_popup_mode");
            }
        },
        redirectToNaverLogin() {
            const clientId = "8OoTuF36z_kbHk8X6i4F";
            const redirectUri = encodeURIComponent(
                `${window.location.origin}${this.$route.path}?mode=${this.getPopupModeParam()}`
            );
            const state = this.naverLogin.getUniqState();
            window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;
        },
        async handleNaverCallback() {
            const code = this.$route.query.code;
            const state = this.$route.query.state;
            try {
                const resp = await axios.get(
                    `/oauth2.0/token?grant_type=authorization_code&client_id=8OoTuF36z_kbHk8X6i4F&client_secret=alQwE9B9hk&code=${code}&state=${state}`
                );
                const token = resp.data.access_token;
                if (!token) throw new Error("토큰 조회 실패");
                await this.fetchNaverUserInfo(token);
            } catch (err) {
                console.error("Error fetching Naver token:", err);
                alert("네이버 로그인에 실패했습니다. 다시 시도해주세요.");
            }
        },
        async fetchNaverUserInfo(accessToken) {
            try {
                const { data } = await axios.get("/v1/nid/me", {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                const r = data.response;
                const user = {
                    USER_ID: r.email,
                    USER_NAME: r.name || r.nickname,
                    USER_EMAIL: r.email,
                    USER_BIRTH:
                        r.birthyear && r.birthday
                            ? `${r.birthyear}-${r.birthday}`
                            : "",
                    USER_MOBILE: r.mobile || "",
                    USER_GENDER: r.gender || "",
                    USER_IN_TYPE: "USER_IN_NAVER",
                };
                sessionStorage.setItem(
                    LOCAL_STORAGE_HVM_USERINFO,
                    JSON.stringify(user)
                );
                sessionStorage.setItem("userData", JSON.stringify(user));
                await this.getMemberCheck(user.USER_ID);
            } catch (err) {
                console.error("Error fetching Naver info:", err);
                alert("네이버 사용자 정보를 가져오는 데 실패했습니다.");
            }
        },
        async getMemberCheck(id) {
            const encryptedId = encryptAES256(id);
            const frcUuid = this.resolveFrcUuid();
            const entUuid = this.resolveEntUuid();
            const entSeq = this.resolveEntSeq();
            const q = this.$route?.query || {};
            const entryType = String(q.entryType || "").toLowerCase();
            const platformParams = this.resolveOptionalPlatformParams();
            const platformUserRaw = String(platformParams.platformUser || "").trim();
            const isCpsFlow = entryType === "cps" && !!platformUserRaw;
            const memberSearchApi = isCpsFlow ? "/bgm/v1/foodcon/id" : "bgm/v1/search/id";
            const memberSearchPayload = isCpsFlow
                ? {
                    platformUser: encryptAES256(platformUserRaw || String(id || "").trim()),
                    ...(entSeq ? { entSeq } : {}),
                    ...(frcUuid ? { frcUuid } : {}),
                }
                : {
                    userId: encryptedId,
                    type: "id",
                    ...(entUuid ? { entUuid } : {}),
                    ...(frcUuid ? { frcUuid } : {}),
                };
            const res = await postAxios(memberSearchApi, memberSearchPayload);

            const ci = (res && (res.CI || res.ci)) || "";
            if (ci) {
                this.updateCpsEntryContext({ ci });
            }

            // 기존 로그인 프로세스는 유지하고, CPS 흐름에서만 CI 조건을 강제한다.
            if (isCpsFlow) {
                if (!ci) {
                    this.proceedToSignup();
                } else {
                    await this.handleLogin();
                }
                return;
            }

            if (!res?.id) {
                this.proceedToSignup();
            } else {
                await this.handleLogin();
            }
        },
        resolveFrcUuid() {
            const q = this.$route?.query || {};
            const byQuery = typeof q.frcUuid === "string" ? q.frcUuid : "";
            if (byQuery) {
                sessionStorage.setItem("foodcon_frc_uuid", byQuery);
                sessionStorage.setItem("frcUuid", byQuery);
                return byQuery;
            }

            try {
                const fromUrl = new URLSearchParams(window.location.search).get("frcUuid") || "";
                if (fromUrl) {
                    sessionStorage.setItem("foodcon_frc_uuid", fromUrl);
                    sessionStorage.setItem("frcUuid", fromUrl);
                    return fromUrl;
                }
            } catch (e) {
                // ignore
            }

            return (
                sessionStorage.getItem("foodcon_frc_uuid") ||
                sessionStorage.getItem("frcUuid") ||
                localStorage.getItem("foodcon_frc_uuid") ||
                localStorage.getItem("frcUuid") ||
                ""
            );
        },
        resolveEntUuid() {
            const q = this.$route?.query || {};
            const byQuery = typeof q.entUuid === "string" ? q.entUuid : "";
            if (byQuery) {
                sessionStorage.setItem("foodcon_ent_uuid", byQuery);
                sessionStorage.setItem("entUuid", byQuery);
                return byQuery;
            }

            try {
                const fromUrl = new URLSearchParams(window.location.search).get("entUuid") || "";
                if (fromUrl) {
                    sessionStorage.setItem("foodcon_ent_uuid", fromUrl);
                    sessionStorage.setItem("entUuid", fromUrl);
                    return fromUrl;
                }
            } catch (e) {
                // ignore
            }

            return (
                sessionStorage.getItem("foodcon_ent_uuid") ||
                sessionStorage.getItem("entUuid") ||
                localStorage.getItem("foodcon_ent_uuid") ||
                localStorage.getItem("entUuid") ||
                ""
            );
        },
        resolveEntSeq() {
            const q = this.$route?.query || {};
            const toInt = (v) => {
                const n = Number(v);
                return Number.isInteger(n) && n > 0 ? n : 0;
            };

            const byQuery = toInt(q.entSeq);
            if (byQuery) {
                sessionStorage.setItem("foodcon_ent_seq", String(byQuery));
                sessionStorage.setItem("entSeq", String(byQuery));
                return byQuery;
            }

            try {
                const fromUrl = toInt(new URLSearchParams(window.location.search).get("entSeq"));
                if (fromUrl) {
                    sessionStorage.setItem("foodcon_ent_seq", String(fromUrl));
                    sessionStorage.setItem("entSeq", String(fromUrl));
                    return fromUrl;
                }
            } catch (e) {
                // ignore
            }

            return toInt(
                sessionStorage.getItem("foodcon_ent_seq") ||
                sessionStorage.getItem("entSeq") ||
                localStorage.getItem("foodcon_ent_seq") ||
                localStorage.getItem("entSeq") ||
                ""
            );
        },
        resolveMarketingReturnPath() {
            const q = this.$route?.query || {};
            const mode = typeof q.mode === "string" ? q.mode : "";
            const entUuid = typeof q.entUuid === "string"
                ? q.entUuid
                : (sessionStorage.getItem("foodcon_ent_uuid") || "");
            const frcUuid = this.resolveFrcUuid();

            const params = new URLSearchParams();
            if (mode) params.set("mode", mode);
            if (entUuid) params.set("entUuid", entUuid);
            if (frcUuid) params.set("frcUuid", frcUuid);

            const query = params.toString();
            return query ? `/HFO_LO_001_POP?${query}` : "/HFO_LO_001_POP";
        },
        async redirectToMarketingConsent(nextAction) {
            this.pendingMemberCheckAction = nextAction;
            this.pendingMarketingUpdate = true;
            await this.loadMarketingTermsContent();
            this.showMarketingConsentPopup = true;
        },
        async resumeMarketingFlowIfNeeded() {
            const isDone = sessionStorage.getItem("hvm_marketing_consent_done") === "Y";
            if (!isDone) return;

            const action = sessionStorage.getItem("hvm_marketing_next_action") || "";
            const needUpdate = sessionStorage.getItem("hvm_marketing_update_pending") === "Y";

            sessionStorage.removeItem("hvm_marketing_consent_done");
            sessionStorage.removeItem("hvm_marketing_next_action");
            sessionStorage.removeItem("hvm_marketing_return_to");
            sessionStorage.removeItem("hvm_marketing_update_pending");

            this.pendingMarketingUpdate = needUpdate;

            if (action === "signup") {
                this.proceedToSignup();
                return;
            }
            if (action === "login") {
                await this.handleLogin();
            }
        },
        async loadMarketingTermsContent() {
            if (this.marketingTermsContent) return;
            try {
                const resp = await getAxios("/hvm/v1/help/contract", {
                    contractType: "CONTRACT_MARKETING",
                });
                const content = resp?.page?.list?.[0]?.rmks || "";
                this.marketingTermsContent =
                    content ||
                    "<p>하이비타민의 통합 마케팅 정보 수신에 동의하시면 카카오톡/문자로 이벤트, 혜택, 프로모션 안내를 받아보실 수 있습니다.</p><p>주문/결제/계정 관련 필수 안내는 동의 여부와 관계없이 발송됩니다.</p>";
            } catch (error) {
                this.marketingTermsContent =
                    "<p>하이비타민의 통합 마케팅 정보 수신에 동의하시면 카카오톡/문자로 이벤트, 혜택, 프로모션 안내를 받아보실 수 있습니다.</p><p>주문/결제/계정 관련 필수 안내는 동의 여부와 관계없이 발송됩니다.</p>";
            }
        },
        updateMarketingSubOptions() {
            if (!this.marketingConsent.checked) {
                this.marketingConsent.emailChecked = false;
                this.marketingConsent.smsChecked = false;
            } else {
                this.marketingConsent.emailChecked = true;
                this.marketingConsent.smsChecked = true;
            }
        },
        updateMarketingChecked() {
            this.marketingConsent.checked =
                this.marketingConsent.emailChecked || this.marketingConsent.smsChecked;
        },
        async confirmMarketingConsent() {
            sessionStorage.setItem(
                "emailChecked",
                this.marketingConsent.emailChecked ? "true" : "false",
            );
            sessionStorage.setItem(
                "smsChecked",
                this.marketingConsent.smsChecked ? "true" : "false",
            );

            this.showMarketingConsentPopup = false;
            if (this.pendingMemberCheckAction === "signup") {
                this.proceedToSignup();
                return;
            }
            await this.handleLogin();
        },
        proceedToSignup() {
            const cpsContext = this.getCpsEntryContext();
            const signupQuery = {};
            const hasCpsTarget = !!(cpsContext && cpsContext.targetUrl);
            if (cpsContext) {
                if (cpsContext.entryType) signupQuery.entryType = cpsContext.entryType;
                if (cpsContext.entUuid) signupQuery.entUuid = cpsContext.entUuid;
                if (cpsContext.frcUuid) signupQuery.frcUuid = cpsContext.frcUuid;
                if (cpsContext.targetUrl) signupQuery.targetUrl = cpsContext.targetUrl;
                if (cpsContext.clickId) signupQuery.clickId = cpsContext.clickId;
                if (cpsContext.adId) signupQuery.adId = cpsContext.adId;
                if (cpsContext.subId) signupQuery.subId = cpsContext.subId;
                if (cpsContext.ci) signupQuery.ci = cpsContext.ci;
            }

            // CPS 타겟이 있는 경우에는 부모 모달을 띄우지 않고 팝업 내부 가입으로 바로 진행한다.
            if (!hasCpsTarget) {
                const payload = { type: 'HVM_LOGIN_NEED_SIGNUP', userData: this.userData || {}, popupId: this.getPopupId() };
                this.postToOpener(payload);
            }
            const isKakaoUser = (this.userData?.USER_IN_TYPE || '') === 'USER_IN_KAKAO';
            this.$router.push({ path: isKakaoUser ? '/HFO_MB_004_SNS' : '/HFO_MB_003', query: signupQuery });
        },
        saveCpsEntryContext() {
            const q = this.$route?.query || {};
            const entUuid = typeof q.entUuid === "string" ? q.entUuid : this.resolveEntUuid();
            const frcUuid = typeof q.frcUuid === "string" ? q.frcUuid : this.resolveFrcUuid();
            const queryEntryType = typeof q.entryType === "string" ? q.entryType.toLowerCase() : "";
            const hasPlatformUser = typeof q.userId === "string" && q.userId.trim().length > 0;
            const fallbackEntryType = entUuid || frcUuid ? "qr" : (hasPlatformUser ? "cps" : "");
            const normalizedEntryType = queryEntryType === "cps" && !hasPlatformUser
                ? (entUuid || frcUuid ? "qr" : "")
                : (queryEntryType || fallbackEntryType);
            const context = {
                entryType: normalizedEntryType,
                userId: typeof q.userId === "string" ? q.userId : "",
                entUuid,
                frcUuid,
                targetUrl: typeof q.targetUrl === "string" ? q.targetUrl : "",
                clickId: typeof q.clickId === "string" ? q.clickId : "",
                adId: typeof q.adId === "string" ? q.adId : "",
                subId: typeof q.subId === "string" ? q.subId : "",
                ci: typeof q.ci === "string" ? q.ci : "",
                createdAt: new Date().toISOString(),
            };
            const serialized = JSON.stringify(context);
            sessionStorage.setItem("cps_entry_context", serialized);
            localStorage.setItem("cps_entry_context", serialized);
        },
        updateCpsEntryContext(patch) {
            const current = this.getCpsEntryContext() || {};
            const merged = {
                ...current,
                ...patch,
                createdAt: current.createdAt || new Date().toISOString(),
            };
            const serialized = JSON.stringify(merged);
            sessionStorage.setItem("cps_entry_context", serialized);
            localStorage.setItem("cps_entry_context", serialized);
        },
        getCpsEntryContext() {
            try {
                const raw = sessionStorage.getItem("cps_entry_context") || localStorage.getItem("cps_entry_context");
                return raw ? JSON.parse(raw) : null;
            } catch (_e) {
                return null;
            }
        },
        resolveOptionalPlatformParams() {
            let platformUser = "";
            let platformGroup = "";

            try {
                const q = this.$route?.query || {};
                const cps = this.getCpsEntryContext() || {};
                platformUser = String(q.platformUser || q.userId || cps.userId || "").trim();
                platformGroup = String(q.platformGroup || q.subId || cps.subId || "").trim();
            } catch (_e) {
                platformUser = "";
                platformGroup = "";
            }

            const result = {};
            if (platformUser) result.platformUser = platformUser;
            if (platformGroup) result.platformGroup = platformGroup;
            return result;
        },
        async handleLogin() {
            try {
                const stored = JSON.parse(
                    sessionStorage.getItem(LOCAL_STORAGE_HVM_USERINFO) || "{}"
                );
                let id = encryptAES256(this.loginData.id);
                let pwd = encryptAES256(this.loginData.password);
                let type = "USER_IN_NORMAL";

                if (stored.USER_IN_TYPE !== "USER_IN_NORMAL") {
                    id = encryptAES256(String(stored.USER_ID));
                    pwd = "";
                    type = stored.USER_IN_TYPE;
                }

                const frcUuid = this.resolveFrcUuid();
                const entUuid = this.resolveEntUuid();
                const entSeq = this.resolveEntSeq();

                const platformParams = this.resolveOptionalPlatformParams();
                const entryType = String(this.$route?.query?.entryType || "").toLowerCase();
                const isCpsFlow = entryType === "cps" && !!platformParams.platformUser;
                const loginPlatformPayload = {
                    ...(platformParams.platformUser
                        ? { platformUser: encryptAES256(String(platformParams.platformUser).trim()) }
                        : {}),
                    ...(platformParams.platformGroup
                        ? { platformGroup: platformParams.platformGroup }
                        : {}),
                };

                const resp = await postAxios("/bgm/v1/mem/login", {
                    userId: id,
                    userPwd: pwd,
                    userInType: type,
                    ...loginPlatformPayload,
                    ...(isCpsFlow && entSeq ? { entSeq } : {}),
                    ...(!isCpsFlow && entUuid ? { entUuid } : {}),
                    ...(frcUuid ? { frcUuid } : {}),
                });

                if (resp.errors) {
                    this.invalidPassword = true;
                    return;
                }

                localStorage.setItem(
                    LOCAL_STORAGE_HVM_USERINFO,
                    JSON.stringify(resp)
                );

                if (this.pendingMarketingUpdate && resp?.userUuid) {
                    try {
                        const emailYn = this.marketingConsent.emailChecked ? "Y" : "N";
                        const smsYn = this.marketingConsent.smsChecked ? "Y" : "N";
                        await putAxios(`bgm/v1/mem/member/${resp.userUuid}`, {
                            emailYn,
                            smsYn,
                        });
                        resp.emailYn = emailYn;
                        resp.smsYn = smsYn;
                        localStorage.setItem(
                            LOCAL_STORAGE_HVM_USERINFO,
                            JSON.stringify(resp)
                        );
                    } catch (error) {
                        console.warn("마케팅 동의 저장 실패:", error);
                    } finally {
                        this.pendingMarketingUpdate = false;
                    }
                }
                SessionManager.startSession();

                if (this.selectedOptions.includes("2")) {
                    localStorage.setItem(LOCAL_STORAGE_HVM_SAVED_ID, this.loginData.id);
                } else {
                    localStorage.removeItem(LOCAL_STORAGE_HVM_SAVED_ID);
                }

                if (resp.pwdChangYn === "Y") {
                    //this.router.push("/HFO_MP_006");
                    //return;
                }

                // 부모에게 로그인 완료 메시지 전송
                const payload = { type: 'HVM_LOGIN_COMPLETED', user: resp, token: resp && resp.token ? resp.token : sessionStorage.getItem('hvm_token') || null, popupId: this.getPopupId() };
                this.postToOpener(payload);
                // ACK 수신을 기다리고, 없으면 부모에 닫기 요청을 재전송한 뒤 자체 종료 시도
                this.ackReceived = false;
                if (this.ackTimeoutId) clearTimeout(this.ackTimeoutId);
                this.ackTimeoutId = setTimeout(() => {
                    if (!this.ackReceived) {
                        console.warn('Popup: no ACK received within timeout, sending close request');
                        try { this.postToOpener({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: this.getPopupId() }); } catch (e) { console.warn('Popup: failed to post close request', e); }
                        try { window.close(); } catch (err) { console.warn('Popup: final close() failed', err); }
                    }
                }, 2000);
                const redirect = this.$route.query.redirect || "/";
                this.$router.push({ path: redirect });
            } catch (err) {
                console.error("로그인 중 오류:", err);
                this.invalidPassword = true;
            }
        },
        postToOpener(payload) {
            try {
                if (window.opener && !window.opener.closed) { window.opener.postMessage(payload, '*'); console.log('Popup: posted to opener', payload); }
                else if (window.parent && window.parent !== window) { window.parent.postMessage(payload, '*'); console.log('Popup: posted to parent', payload); }
                else console.warn('Popup: no opener/parent to post message to');
            } catch (err) { console.error('Popup: postMessage failed', err); }
        },

        // Measure content size and post message to opener so it can resize the popup window.
        sendContentSize() {
            try {
                // Prefer measuring the main login box so popup hugs the important content.
                const box = document.querySelector('.login_box_area.login_box_area2') || document.querySelector('.login_box_area2');
                const root = document.querySelector('.sub_contents.login');
                const frameWidth = Math.max(0, (window.outerWidth || 0) - (window.innerWidth || 0));
                const frameHeight = Math.max(0, (window.outerHeight || 0) - (window.innerHeight || 0));
                const verticalSafetyGap = 20;
                let width, height;
                if (box) {
                    const rect = box.getBoundingClientRect();
                    let extraVertical = 0;
                    if (root) {
                        const rootStyle = window.getComputedStyle(root);
                        const paddingTop = parseFloat(rootStyle.paddingTop || '0') || 0;
                        const paddingBottom = parseFloat(rootStyle.paddingBottom || '0') || 0;
                        extraVertical = Math.ceil(paddingTop + paddingBottom);
                    }
                    // Add a small padding (~3%) so popup isn't too tight but avoid large bottoms
                    width = Math.ceil(rect.width * 1.03) + frameWidth + 8;
                    height = Math.ceil(rect.height * 1.03) + extraVertical + frameHeight + verticalSafetyGap;
                } else {
                    const body = document.body;
                    const html = document.documentElement;
                    const contentWidth = Math.max(
                        body?.scrollWidth || 0,
                        body?.offsetWidth || 0,
                        html?.clientWidth || 0,
                        html?.scrollWidth || 0,
                        html?.offsetWidth || 0,
                    );
                    const contentHeight = Math.max(
                        body?.scrollHeight || 0,
                        body?.offsetHeight || 0,
                        html?.clientHeight || 0,
                        html?.scrollHeight || 0,
                        html?.offsetHeight || 0,
                    );
                    width = Math.ceil(contentWidth) + frameWidth + 8;
                    height = Math.ceil(contentHeight) + frameHeight + verticalSafetyGap;
                }

                // Clamp to sensible min/max so browser doesn't refuse or create extreme sizes
                const screenAvailW = window.screen?.availWidth || window.innerWidth || 560;
                const screenAvailH = window.screen?.availHeight || window.innerHeight || 920;
                const minW = 340; const maxW = Math.min(560, Math.max(420, screenAvailW - 40));
                const minH = 320; const maxH = Math.min(940, Math.max(620, screenAvailH - 40));
                width = Math.max(minW, Math.min(maxW, parseInt(width, 10)));
                height = Math.max(minH, Math.min(maxH, parseInt(height, 10)));

                const payload = { type: 'HVM_POPUP_CONTENT_SIZE', width, height };
                if (window.opener && !window.opener.closed) {
                    try { window.opener.postMessage(payload, '*'); console.log('Popup: sent content size to opener', payload); }
                    catch (e) { console.warn('Popup: sendContentSize postMessage failed', e); }
                } else if (window.parent && window.parent !== window) {
                    try { window.parent.postMessage(payload, '*'); console.log('Popup: sent content size to parent', payload); }
                    catch (e) { console.warn('Popup: sendContentSize postMessage to parent failed', e); }
                } else {
                    // no opener - probably running in-modal; nothing to do
                }
            } catch (e) { console.warn('sendContentSize error', e); }
        },

        startContentSizeWatcher() {
            // Send a few reports while content (images, SDKs) finish loading, then stop
            this.stopContentSizeWatcher();
            this.sendContentSize();
            this.contentSizeTicks = 0;
            this.contentSizeWatcherId = setInterval(() => {
                this.contentSizeTicks += 1;
                this.sendContentSize();
                if (this.contentSizeTicks >= 12) { // ~3 seconds at 250ms
                    this.stopContentSizeWatcher();
                }
            }, 250);
        },

        stopContentSizeWatcher() {
            if (this.contentSizeWatcherId) {
                try { clearInterval(this.contentSizeWatcherId); } catch (e) { /* ignore */ }
                this.contentSizeWatcherId = null;
                this.contentSizeTicks = 0;
            }
        },
        getPopupId() { try { return window.name || 'unknown_popup'; } catch (e) { return 'unknown_popup'; } },
        handleAckMessage(e) {
            try {
                const data = e.data || {};
                if (data && data.type === 'HVM_LOGIN_ACK') {
                    if (!data.popupId || data.popupId === this.getPopupId()) {
                        console.log('Popup: received ACK for popupId', data.popupId);
                        this.ackReceived = true;
                        if (this.ackTimeoutId) { clearTimeout(this.ackTimeoutId); this.ackTimeoutId = null; }
                        try { window.close(); } catch (err) { console.warn('Popup.close failed', err); }
                    }
                }
            } catch (err) { console.warn('Popup: handleAckMessage error', err); }
        },
        initSavedId() {
            const saved = localStorage.getItem(LOCAL_STORAGE_HVM_SAVED_ID);
            if (saved) {
                if (!this.selectedOptions.includes("2")) {
                    this.selectedOptions.push("2");
                }
                this.loginData.id = saved;
            }
        },
        onCheckboxChange() {
            if (this.selectedOptions.includes("2")) {
                localStorage.setItem(
                    LOCAL_STORAGE_HVM_SAVED_ID,
                    this.loginData.id
                );
            } else {
                localStorage.removeItem(LOCAL_STORAGE_HVM_SAVED_ID);
            }
        },
        hideErrorMessages() {
            this.invalidPassword = false;
        },
        closeAlert() {
            this.showAlert = false;
        },
    },
};
</script>

<style scoped>
/* 팝업 전용 스타일 - 헤더/푸터 없음 */
.sub_contents.login {
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: clamp(64px, 20vh, 180px) 18px 16px 18px !important;
    box-sizing: border-box;
    overflow-y: visible;
}

.sub_contents.login.popup-standalone-desktop {
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: clamp(64px, 20vh, 180px) 0 16px !important;
}

.sub_contents.login.popup-window-mode {
    padding: clamp(36px, 12vh, 96px) 18px 16px 18px !important;
}

.sub_contents.login.popup-standalone-desktop .cont_center {
    max-width: 520px;
    padding: 0;
}

.sub_contents.login.popup-standalone-desktop .login_box_area.login_box_area2 {
    padding: 36px 34px;
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.18);
    border: 1px solid #eee;
}

.cont_center {
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
}

/* 기존 스타일 유지 */
.login_box_area.login_box_area2 {
    width: 100%;
    padding: 24px 22px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.16);
    margin-bottom: 0;
}

.brand_title_row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.brand_logo_img {
    width: 108px;
    height: auto;
    opacity: 0.95;
}

.title_login {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    color: #333;
}

.title_login.title_inline {
    margin: 0;
    font-size: 28px;
    line-height: 1;
}

.welcome_copy {
    text-align: center;
    padding-top: 20px;
    margin-bottom: 6px;
    color: #3d3d3d;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.2px;
    line-height: 1.4;
}

.benefit_copy {
    text-align: center;
    margin: -4px 0 6px;
    color: #5f5f5f;
    font-size: 14px;
    line-height: 1.45;
    word-break: keep-all;
}

.benefit_orange {
    color: #ee7528;
    font-weight: 600;
}

.benefit_default {
    color: #333333;
}

.benefit_green {
    color: #80a600;
    font-weight: 700;
}

.benefit_break_mobile {
    display: none;
}

.login_input_area {
    width: 100%;
}

.login_input_list {
    margin-bottom: 8px;
}

.login_input_list li {
    margin-bottom: 8px;
    padding-bottom: 0 !important;
}

.login_input_area .login_check_area {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

.login_input_area .login_check_area :deep(.d_check label) {
    line-height: 24px;
}

.login_input_area .btn_login_area {
    margin-top: 0 !important;
    margin-bottom: 10px;
}

.btn_login_area .btn_type2 {
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #ee7528;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    display: block;
}

.btn_login_area .btn_type2:hover {
    background: #d66520;
}

.login_user_link {
    text-align: center;
    margin-bottom: 30px;
}

.login_user_link li {
    display: inline-block;
    margin: 0 10px;
}

.login_user_link a {
    color: #666;
    text-decoration: none;
    font-size: 14px;
}

.login_user_link a:hover {
    text-decoration: underline;
}

.sns_login_wrapper {
    position: relative;
    border: 2px solid #ee7528;
    border-radius: 5px;
    padding: 0px 10px 10px;
    margin-top: 10px;
}

.sns_login_title {
    position: absolute;
    top: -12px;
    left: 15px;
    background: #fff;
    padding: 0 8px;
    color: #ee7528;
    margin: 0;
    font-size: 16px;
}

.sns_login {
    padding: 0 !important;
    margin: 0 !important;
}

.sns_login>li {
    margin-top: 12px !important;
}

.sns_login>li a {
    display: block;
    text-decoration: none;
}

.sns_login>li img {
    width: 100%;
    max-width: 335px;
    height: auto;
    border-radius: 5px;
}

.sns_divider {
    position: relative;
    margin: 14px 0 4px !important;
    text-align: center;
}

.sns_divider::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    border-top: 1px solid #e9e9e9;
}

.sns_divider span {
    position: relative;
    z-index: 1;
    display: inline-block;
    padding: 0 10px;
    background: #fff;
    color: #999;
    font-size: 12px;
    font-weight: 500;
}

.kakao_priority_item {
    margin-top: 14px !important;
    margin-bottom: 2px;
}

.kakao_priority_link {
    border-radius: 8px;
    box-shadow: 0 8px 18px rgba(250, 224, 0, 0.35);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kakao_priority_link:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(250, 224, 0, 0.4);
}

.naver_secondary_item {
    margin-top: 8px !important;
}

.naver_secondary_link {
    opacity: 0.95;
}

.login-error-message {
    margin-top: 8px !important;
    margin-bottom: 0 !important;
    display: block !important;
    clear: both !important;
    position: relative !important;
    z-index: 1 !important;
}

.required.login-error-message {
    color: #ff4444;
    font-size: 16px;
    line-height: 1.4;
}

.popup_actions {
    margin-top: 18px !important;
}

/* 반응형 디자인 */
@media (max-width: 480px) {
    .sub_contents.login {
        align-items: flex-start;
        padding: clamp(56px, 20vh, 132px) 10px 12px !important;
    }

    .login_box_area.login_box_area2 {
        padding: 18px 14px;
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
    }

    .brand_logo_area {
        margin-bottom: 10px;
    }

    .brand_logo_img {
        width: 118px;
    }

    .title_login {
        font-size: 20px;
        margin-bottom: 6px;
    }

    .welcome_copy {
        margin-bottom: 6px;
        font-size: 15px;
    }

    .benefit_copy {
        margin: -2px 0 6px;
        font-size: 13px;
    }

    .benefit_break_mobile {
        display: block;
    }

    .sns_login_wrapper {
        margin-top: 8px;
    }
}
</style>
